import { useTranslation } from 'libs/i18n';
import { OnboardingTaxResidency } from 'modules/onboarding/common/components';

import { useTaxResidency } from '../hooks';
import { useOnboardingContext } from '../hooks/useOnboardingContext';
import { PageComponentProps } from '../types';

export const TaxResidencyStep = ({ canGoBack }: PageComponentProps) => {
  const {
    countries,
    countriesLoading,
    initialValues,
    submitLoading,
    onSubmit,
    goToBack,
  } = useTaxResidency();

  const { step } = useOnboardingContext();
  const { t } = useTranslation();

  return (
    <OnboardingTaxResidency
      canGoBack={canGoBack}
      countries={countries}
      countriesLoading={countriesLoading}
      initialValues={initialValues}
      step={step}
      submitLoading={submitLoading}
      subTitle={t('onboarding.legalClientFirstHead.taxResidency.subtitle')}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
